document.addEventListener('DOMContentLoaded', function() {
  function calculateShippingDate(delay) {
    const today = new Date();
    const daysToAdd = parseInt(delay) || 3;
    let deliveryDate = new Date(today);

    let addedDays = 0;
    while (addedDays < daysToAdd) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) {
        addedDays++;
      }
    }

    const options = { weekday: "long", day: "numeric", month: "long" };
    return deliveryDate.toLocaleDateString("fr-FR", options);
  }

  const shippingCalculators = document.querySelectorAll('.atc-bundle-sor__shipping-calculator');
  shippingCalculators.forEach(calculator => {
    const delay = calculator.dataset.shippingDelay;
    const dateElement = calculator.querySelector('.shipping-date');
    if (dateElement) {
      dateElement.textContent = calculateShippingDate(delay);
    }
  });
});
